import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
import { FWCustomParams } from 'tag/ts/tag/model/ads/freewheel/FWCustomParams';
import { FWGlobalParams } from 'tag/ts/tag/model/ads/freewheel/FWGlobalParams';
import { FWSiteParams } from 'tag/ts/tag/model/ads/freewheel/FWSiteParams';
export class FreewheelModel extends AbstractFreewheelClass {
    #globalParams;
    #siteParams;
    #customParams;
    #adParams;
    #adSetupInfo;
    constructor(argument) {
        super({
            ...argument,
            name: 'FreewheelModel'
        });
        this.#adSetupInfo = argument?.tag?.model?.adUtilities?.adSetupInfo();
        this.#globalParams = new FWGlobalParams({ tag: argument?.tag, adSetupInfo: this.#adSetupInfo });
        this.#siteParams = new FWSiteParams({ tag: argument?.tag, adSetupInfo: this.#adSetupInfo });
        this.#customParams = new FWCustomParams({ tag: argument?.tag, adSetupInfo: this.#adSetupInfo });
        this.#adParams = {
            ...(this.#globalParams.adParameters || {}),
            ...(this.#siteParams.adParameters || {}),
            ...(this.#customParams.adParameters || {})
        };
    }
    get globalParams() {
        return this.#globalParams;
    }
    get siteParams() {
        return this.#siteParams;
    }
    get customParams() {
        return this.#customParams;
    }
    get adSetupInfo() {
        return this.#adSetupInfo;
    }
    get adParameters() {
        return this.#adParams;
    }
}
